import { Controller } from "@hotwired/stimulus"

// The admin shell: the mobile menu and New sheets, the desktop New menu, and keyboard shortcuts
// (N new, G then H/T/E/W/C to jump to Home, To do, Events, Editions or Cities). ⌘K and / belong to the
// palette (command_palette_controller).
export default class extends Controller {
  static targets = ["navSheet", "newSheet", "newMenu"]

  connect() {
    this.closeBeforeCache = () => this.closeAll()
    document.addEventListener("turbo:before-cache", this.closeBeforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.closeBeforeCache)
  }

  openNav() {
    this.navSheetTarget.showModal()
  }

  openNew() {
    this.newSheetTarget.showModal()
  }

  openPalette() {
    this.closeAll()
    window.dispatchEvent(new CustomEvent("admin-palette:open"))
  }

  closeSheets() {
    for (const sheet of [this.navSheetTarget, this.newSheetTarget]) if (sheet.open) sheet.close()
  }

  backdropClick(event) {
    if (event.target === event.currentTarget) event.currentTarget.close()
  }

  // A click anywhere outside an open menu closes it
  closeMenus(event) {
    this.element.querySelectorAll("details[data-menu][open]").forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false
    })
  }

  closeAll() {
    this.closeSheets()
    this.element.querySelectorAll("details[data-menu][open]").forEach((menu) => (menu.open = false))
  }

  hotkey(event) {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.altKey || this.typing(event.target)) return
    if (document.documentElement.hasAttribute("data-drawer-open")) return

    if (event.key === "Escape") return this.closeAll()

    // The key after G belongs to the shortcut, so page shortcuts (To do's) leave it alone
    if (this.pendingG) {
      this.pendingG = false
      event.preventDefault()
      const path = { h: "/admin", t: "/admin/todo", e: "/admin/events", w: "/admin/weeks", c: "/admin/cities" }[event.key.toLowerCase()]
      if (path) window.Turbo ? window.Turbo.visit(path) : (window.location = path)
      return
    }

    switch (event.key) {
      case "n":
      case "N":
        if (this.hasNewMenuTarget && this.newMenuTarget.offsetParent !== null) {
          event.preventDefault()
          this.newMenuTarget.open = true
          this.newMenuTarget.querySelector("[role=menuitem]")?.focus()
        }
        break
      case "g":
      case "G":
        this.pendingG = true
        clearTimeout(this.gTimer)
        this.gTimer = setTimeout(() => (this.pendingG = false), 1200)
        break
    }
  }

  typing(element) {
    if (element.tagName === "INPUT") return !["checkbox", "radio", "button", "submit"].includes(element.type)
    return element.isContentEditable || ["TEXTAREA", "SELECT"].includes(element.tagName)
  }
}
